import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    alignSelf: "center",
  },
  menuItem: {
    fontSize: theme.typography.inputText.fontSize,
  },
}));
